import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/keywords';
const baseAnalysis = '/api/v1/purple-post/analysis';

export default {
  getPostAnalysis(postId) {
    return axios.get(`${baseAnalysis}/for-post/${postId}`);
  },
  getAllKeywords(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/prison${queryString}`);
  },
  createKeyword(keyword) {
    return axios.post(`${base}/create`, keyword);
  },
  updateKeyword(keywordId, keyword) {
    return axios.post(`${base}/update/${keywordId}`, keyword);
  },
  deleteKeyword(keywordId) {
    return axios.delete(`${base}/delete/${keywordId}`);
  },
};
